import { render } from "./LangagesUsed.vue?vue&type=template&id=754f63c4"
import script from "./LangagesUsed.vue?vue&type=script&lang=js"
export * from "./LangagesUsed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__